import React from 'react'
import PropTypes from 'prop-types'

const fmt = n => '$' + n.toFixed(2)

export const CatalogRow = ({ item, isAdded, isRequired, saving, onAdd }) => {
  const clickable = !isAdded && !saving

  const handleClick = () => {
    if (clickable) onAdd(item.id)
  }

  return (
    <div
      className={`d-flex align-items-center border rounded p-2 ${clickable ? 'cli-catalog-row' : ''} ${isAdded ? 'bg-success-light' : ''}`}
      style={{
        gap: '12px',
        padding: '10px 14px',
        transition: 'background 0.1s',
        userSelect: 'none',
        cursor: clickable ? 'pointer' : 'default',
        background: isAdded ? '#f0fdf4' : undefined,
      }}
      role={clickable ? 'button' : 'presentation'}
      tabIndex={clickable ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={e => {
        if ((e.key === 'Enter' || e.key === ' ') && clickable) {
          e.preventDefault()
          handleClick()
        }
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>
        <span className="font-weight-bold" style={{ fontSize: '13px', color: '#111827' }}>
          {item.name}
        </span>
        {item.description && (
          <span className="text-muted ml-1" style={{ fontSize: '12px' }}>{item.description}</span>
        )}
        {isRequired && (
          <span className="text-muted text-uppercase ml-2" style={{ fontSize: '10px', fontWeight: 600, letterSpacing: '0.4px' }}>
            Standard
          </span>
        )}
      </span>
      <span className="font-weight-bold text-muted text-nowrap" style={{ fontSize: '13px', flexShrink: 0 }}>
        +{fmt(item.defaultPrice)}
      </span>
    </div>
  )
}

CatalogRow.propTypes = {
  item: PropTypes.object.isRequired,
  isAdded: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
}
